import React from 'react';
import { TimelineEvent } from '../../services/api';
import './TimelineTab.css';

interface TimelineTabProps {
  timeline: TimelineEvent[];
  formatDateTime: (date: string) => string;
}

const TimelineTab: React.FC<TimelineTabProps> = ({ timeline, formatDateTime }) => {
  return (
    <div className="timeline-list">
      {timeline.length === 0 ? (
        <div className="empty-state">No timeline events available</div>
      ) : (
        timeline.map((event, index) => {
          try {
            const eventType = event?.eventType || 'UNKNOWN';
            const description = event?.description || 'No description';
            const timestamp = event?.timestamp || '';
            const actorName = event?.actorName;

            return (
              <div key={index} className="timeline-item">
                <div className="timeline-icon">
                  {eventType === 'NOTE_CREATED'
                    ? '📝'
                    : eventType === 'CONTACT_ADDED'
                    ? '👤'
                    : eventType === 'DOCUMENT_UPLOADED'
                    ? '📄'
                    : '🔔'}
                </div>
                <div className="timeline-content">
                  <div className="timeline-header">
                    <span className="timeline-event">{eventType.replace(/_/g, ' ')}</span>
                    <span className="timeline-date">{formatDateTime(timestamp)}</span>
                  </div>
                  <div className="timeline-description">{description}</div>
                  {actorName && <div className="timeline-actor">By {actorName}</div>}
                </div>
              </div>
            );
          } catch (error) {
            console.error('Error rendering timeline event:', error, event);
            return null;
          }
        })
      )}
    </div>
  );
};

export default TimelineTab;

